import { createSlice } from "@reduxjs/toolkit";
import type { IMasterState } from "./imports";
import { ILOBTypes } from "./types";

const initialState: IMasterState = {
  userData: [],
  lobList: [],
  lobOptions: [],
  memberList: [],
  memberOptions: [],
};

const masterSlice = createSlice({
  name: "masterSlice",
  initialState,
  reducers: {
    userData: (state, action) => {
      state.userData = action.payload;
    },
    setLobList: (state, action) => {
      state.lobList = action.payload;
      state.lobOptions = action.payload.map((lob: ILOBTypes) => ({
        value: lob.id,
        label: lob.display_name,
      }));
    },
    setMemberList: (state, action) => {
      state.memberList = action.payload;
      state.memberOptions = action.payload.map((member: any) => ({
        value: member.id,
        label: member?.employee?.full_name,
      }));
    },
  },
});

export const { userData, setLobList, setMemberList } = masterSlice.actions;
export default masterSlice.reducer;
